import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form", "promocode", "submit", "sendForm", "checkbox", "terms_and_conditions", "enter_promocode"];
  
  connect(){
    if (document.getElementById("action_path")){
      var textField = this.promocodeTarget;
      var submitField = this.submitTarget;
      if (textField.value.length > 0){
        submitField.classList.remove("disabled")
        submitField.classList.add("primary")
      }else {
        this.promocodeTarget.addEventListener("input", function(){
          if(textField.value.length > 0){
            submitField.classList.remove("disabled")
            submitField.classList.add("primary")
            
          } else {
            submitField.classList.add("disabled")
            submitField.classList.remove("primary")
          }
        });
      }
    }
    
    if(document.getElementById("terms_and_conditions")){
      this.terms_and_conditionsTarget.style.display = "none";
    }
    if(document.getElementById("enter_promocode")){
      this.enter_promocodeTarget.style.pointerEvents = "none";
    }
  }
  check_terms_and_conditions(){
    if(this.checkboxTarget.checked){
      this.terms_and_conditionsTarget.style.display = "none";
    }
    else{
      this.terms_and_conditionsTarget.style.display = "block";
    }
  }
  buttonEnable(){
    
    if(this.checkboxTarget.checked){
      this.submitTarget.classList.remove('unclickable');
      //this.submitTarget.classList.add('custom-active');
      this.terms_and_conditionsTarget.style.display = "none";
      this.enter_promocodeTarget.style.pointerEvents = "auto";
    }
    else{
      this.submitTarget.classList.add('unclickable');
      this.enter_promocodeTarget.style.pointerEvents = "none";
    }
  }

  runAction({ params }){
    if(params.name === "visit_partner"){
      if (window?.Android && typeof window.Android.onNavigateToPartnerPage == "function") {
        Android.onNavigateToPartnerPage();
        return null;
      } else if (window.webkit && window.webkit.messageHandlers) {
        webkit.messageHandlers.performAction.postMessage({
          action: "partnerList",
          data: {
            order: "distance"
          }
        });
      } 
    } else if(params.name === "invite_friend"){
      const data = {
        title: "Win Zone in Enjoyyit!",
        text: "Get enjoyyit and use code ENJOYYIT to get 2 tickets for Win Zone!",
        url: `/web/winzones/promocode?code=${this.promocodeTarget.value}`
      }
      if (window?.Android && typeof window.Android.shareCode == "function") {
        Android.shareCode(data.title, data.text, data.url);
        return null;
      } else if (navigator.share) {
        navigator.share({
            title: data.title,
            text: data.text,
            url: data.url
        })
      }
    }  else if(params.name === "claim_coupon"){
      if (window?.Android && typeof window.Android.onNavigateToCouponPage == "function") {
        Android.onNavigateToCouponPage();
        return null;
      } else if (window.webkit && window.webkit.messageHandlers) {
        webkit.messageHandlers.performAction.postMessage({
          action: "openCouponsTab"
        });
      }
    } else if(params.name === "claim_loyalty"){
      if (window?.Android) {
        Android.onNavigateToLoyaltyPage();
        return null;
      } else if (window.webkit && window.webkit.messageHandlers) {
        webkit.messageHandlers.performAction.postMessage({
          action: "openLoyaltyTab"
        });
      }
    } else if(params.name === "wishlist"){
      if (window?.Android && typeof window.Android.onNavigateToWishList == "function") {
        Android.onNavigateToWishList("/web/wish_items?navbar=true");
        return null;
      } else if (window.webkit && window.webkit.messageHandlers) {
        webkit.messageHandlers.performAction.postMessage({
          action: "openWishlistTab"
        });
      }
    } else if(params.name === "check_in" || params.name === "redeem"){
      if (window?.Android && typeof window.Android.showQRBottomSheet == "function") {
        Android.showQRBottomSheet();
        return null;
      } else if (window.webkit && window.webkit.messageHandlers) {
        webkit.messageHandlers.performAction.postMessage({
          action: "openQR"
        });
      }
    }
  }

  appLink(){
    if(navigator.userAgent.toLowerCase().indexOf("android") > -1){
      window.location.href = 'https://play.google.com/store/apps/details?id=dev.rnm.enjoyyit_public&referrer=adjust_reftag';
      }
    else if ((navigator.userAgent.toLowerCase().indexOf("iphone") > -1)) {
      window.location = `enjoyyit${this.application_type()}://`;
      setTimeout(function() {
        window.location = 'itms-apps://itunes.apple.com/us/app/enjoyyit-einfach-sparen/id1616303065'
      }, 250);
    }
  }

  application_type(){
    switch (project_env) {
      case "development":
        return "-dev";
      case "qa":
        return "-qa";
      default:
        return "";
    }
  }
}
